import React, { Component } from 'react';

import ProtocolButtons from './protocol-buttons';

export default class ProtocolItem extends Component {
	getExcerpt( post ) {
		return 'undefined' !== typeof post.excerpt
			? post.excerpt.rendered
			: post.content.rendered.substring( 0, 140 );
	}

	render() {
		const protocol = this.props.protocol;
		return (
			<article className="two-col-content-panel">
				<div className="col-sm-8">
					<div role="tabpanel" className="tab-pane fade in active">
						<header>
							<div className="entry-meta">
								{ /* @todo: add open date, close/open status */ }
							</div>
							<h3 className="entry-title">
								<a href={ protocol.link } dangerouslySetInnerHTML={ { __html: protocol.title.rendered } } />
							</h3>
						</header>
						<div className="entry-content" dangerouslySetInnerHTML={ { __html: this.getExcerpt( protocol ) } } />
					</div>
				</div>
				<div className="col-sm-4 attached-documents">
					<ProtocolButtons link={ protocol.link } type={ protocol.protocol_type } is_open={ protocol.is_open } />
				</div>
			</article>
		);
	}
}